import { Dispatch, SetStateAction } from 'react'
import { useNavigate } from 'react-router'
import { Button, DialogContent, DialogContentText, Grid } from '@mui/material'

import DialogWithTitle from '../../../../components/dialog-with-title'

import useStyles from './index.styles'

interface IProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
}

const DiscardModal = (props: IProps) => {
  const { open, setOpen } = props

  const classes = useStyles
  const navigate = useNavigate()

  return (
    <DialogWithTitle title="Unsaved Changes" open={open} setOpen={setOpen}>
      <DialogContent>
        <DialogContentText sx={classes.text}>Are you sure you want to leave this page?</DialogContentText>

        <DialogContentText sx={classes.text}>Changes you made will not be saved</DialogContentText>

        <Grid
          container={true}
          sx={{
            justifyContent: 'flex-end',
          }}
        >
          <Button variant="outlined" sx={classes.dialogButtons} onClick={() => setOpen(false)}>
            Cancel
          </Button>

          <Button variant="contained" sx={classes.dialogButtons} onClick={() => navigate('/release-notes')}>
            Leave Page
          </Button>
        </Grid>
      </DialogContent>
    </DialogWithTitle>
  )
}

export default DiscardModal
